export const questions = {
  // Questions for Sports Photography
  Sports: [
    {
      id: "teamName",
      text: "What is the name of the team or event?",
      type: "text",
      placeholder: "E.g., Priory Ravens Hockey",
    },
    {
      id: "location",
      text: "Where will the event take place?",
      type: "text",
      placeholder: "E.g., Centene Community Ice Center",
    },
    {
      id: "date",
      text: "What is the date of the game or event?",
      type: "date",
    },
  ],
  // Questions for Headshot Photography
  Headshots: [
    {
      id: "headshotType",
      text: "What kind of headshots are you looking for?",
      type: "choice",
      options: ["Professional/Corporate", "Creative/Artistic", "Actor/Model"],
    },
    {
      id: "location",
      text: "Do you have a preferred location?",
      type: "text",
      placeholder: "E.g., My office, a local park, etc.",
    },
    {
      id: "numberOfPeople",
      text: "How many people need headshots?",
      type: "number",
    },
  ],
  // NEW: Questions for Portraits
  Portraits: [
    {
      id: "portraitType",
      text: "What type of portrait session is this?",
      type: "choice",
      options: ["Family", "Senior Pictures", "Couples", "Individual"],
    },
    {
      id: "location",
      text: "Do you have a location in mind?",
      type: "text",
      placeholder: "E.g., Forest Park, my home, etc.",
    },
    {
      id: "desiredDate",
      text: "What is your desired date for the session?",
      type: "date",
    },
  ],
  // NEW: Questions for Real Estate
  "Real Estate": [
    {
      id: "propertyAddress",
      text: "What is the address of the property?",
      type: "text",
      placeholder: "123 Main St, Anytown, USA",
    },
    {
      id: "propertySqFt",
      text: "What is the approximate square footage?",
      type: "text",
      placeholder: "E.g., 2,500 sq ft",
    },
    {
      id: "servicesNeeded",
      text: "What services are you interested in?",
      type: "choice",
      options: [
        "Interior & Exterior Photos",
        "Video Walkthrough",
        "Drone Footage",
        "Full Package",
      ],
    },
  ],
  // NEW: Questions for Commercial
  Commercial: [
    {
      id: "businessName",
      text: "What is the name of your business or brand?",
      type: "text",
    },
    {
      id: "projectType",
      text: "What is the nature of this project?",
      type: "choice",
      options: [
        "Product Photography",
        "Brand Lifestyle",
        "Marketing Material",
        "Website Content",
      ],
    },
    {
      id: "projectBrief",
      text: "Please briefly describe the project and your goals.",
      type: "textarea",
      placeholder:
        "E.g., We need clean product shots for our new e-commerce website...",
    },
  ],
  // NEW: Questions for Events
  Events: [
    {
      id: "eventName",
      text: "What is the name of the event?",
      type: "text",
      placeholder: "E.g., 2025 Annual Charity Gala",
    },
    {
      id: "eventDate",
      text: "What is the date of the event?",
      type: "date",
    },
    {
      id: "hoursNeeded",
      text: "How many hours of coverage will you need?",
      type: "number",
      placeholder: "E.g., 4",
    },
  ],
  // NEW: Questions for Drone/Ariel
  "Drone/Ariel": [
    {
      id: "droneSubject",
      text: "What is the primary subject of the shoot?",
      type: "choice",
      options: [
        "Real Estate Property",
        "Construction Site",
        "Outdoor Event",
        "Landscape",
      ],
    },
    {
      id: "locationAddress",
      text: "What is the full address or coordinates of the location?",
      type: "text",
    },
    {
      id: "deliverables",
      text: "What do you need delivered?",
      type: "choice",
      options: [
        "High-Resolution Photos",
        "Edited Video",
        "Both Photos & Video",
      ],
    },
  ],
  Other: [
    {
      id: "details",
      text: "Please describe the photography you need.",
      type: "textarea",
      placeholder: "Tell me about your project...",
    },
  ],
  contactInfo: [
    {
      id: "contactName",
      text: "What is your full name?",
      type: "text",
      placeholder: "E.g., John Doe",
    },
    {
      id: "contactEmail",
      text: "What is your email address?",
      type: "text",
      validationType: "email",
      placeholder: "E.g., john.doe@example.com",
    },
    {
      id: "contactPhone",
      text: "What is a good phone number to reach you?",
      type: "text",
      validationType: "phone",
      placeholder: "E.g., (555) 123-4567",
    },
  ],
};
